import React from "react";
import cx from "classnames";

import InteractiveStarRating from "components/InteractiveStarRating";

type Props = {
  invalid: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  setRating: any;
  rating?: number | null;
  errorMessage?: string | null;
  title: string;
};

const RatingCard: React.FC<Props> = ({
  invalid,
  rating,
  setRating,
  title,
  errorMessage,
}) => {
  return (
    <>
      <section
        className={cx(
          "shadow-low rounded flex flex-col justify-between mb-lg p-xl",
          {
            "border-2 border-error": invalid && !rating,
          },
        )}
      >
        <div
          className={cx("text-center mb-sm", {
            "text-error": invalid && !rating,
          })}
        >
          {title}
        </div>

        <div className="m-auto">
          <InteractiveStarRating
            onSetRating={(rating) => setRating(rating)}
            name={title}
          />
        </div>
      </section>
      {!rating && invalid && (
        <div className="text-error text-xs">{errorMessage}</div>
      )}
    </>
  );
};

export default RatingCard;
